const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const getUrlsRec = (obj: any): string[] => {
	const urls = [];

	for (const key in obj) {
		if (isObject(obj[key])) {
			const recUrls = getUrlsRec(obj[key]);
			urls.push(...recUrls);
		} else {
			urls.push(obj[key]);
		}
	}

	return urls;
}

export const baseUrls = {
	publisher: {
		main: '/publisher',
		templates: {
			list: '/publisher/templates',
			add: '/publisher/templates/add',
			edit: '/publisher/templates/edit/:_id'
		},
		articles: {
			list: '/publisher/articles',
			add: '/publisher/articles/add',
			edit: '/publisher/articles/edit/:_id',
			addFromTemplate: '/publisher/articles/add-from-template',
			addFromTemplateId: '/publisher/articles/add-from-template/:templateId',
			stats: '/publisher/articles/stats/:_id'
		},
		promotionalContent: {
			list: '/publisher/promotional-content',
			add: '/publisher/promotional-content/add',
			edit: '/publisher/promotional-content/edit/:_id'
		},
		promotionalPage: {
			list: '/publisher/promotional-page',
			add: '/publisher/promotional-page/add',
			edit: '/publisher/promotional-page/edit/:_id'
		},
		tags: {
			list: '/publisher/tags',
			add: '/publisher/tags/add',
			edit: '/publisher/tags/edit/:_id'
		},
		users: {
			list: '/publisher/users',
			edit: '/publisher/users/edit/:_id'
		},
		desks: {
			list: '/publisher/desks',
			add: '/publisher/desks/add',
			edit: '/publisher/desks/edit/:_id'
		},
		premiumChannels: {
			list: '/publisher/premium-channels',
			add: '/publisher/premium-channels/add',
			edit: '/publisher/premium-channels/edit/:_id',
			subscribersStatsMain: '/publisher/premium-channels/subscriber-stats',
			subscribersStats: '/publisher/premium-channels/subscriber-stats/:_id',
			subscriberMain: '/publisher/premium-channels/subscribers',
			addSubscriber: '/publisher/premium-channels/subscribers/:_id/add',
			editSubscriber: '/publisher/premium-channels/subscribers/:_id/edit/:neonUserId',
			bulkAddSubscribers: '/publisher/premium-channels/subscribers/:_id/add-bulk'
		},
		categories: {
			list: '/publisher/categories',
			add: '/publisher/categories/add',
			edit: '/publisher/categories/edit/:_id',
			subscribersStats: '/publisher/categories/subscriber-stats/:_id'
		},
		topics: {
			list: '/publisher/topics',
			add: '/publisher/topics/add',
			edit: '/publisher/topics/edit/:_id',
			subscribersStats: '/publisher/topics/subscriber-stats/:_id'
		}
	},
	browse: {
		main: '/browse',
		article: '/browse/article/:_id/:campaignIdAndType?',
		category: '/browse/:categoryId',
		channelMain: '/browse/channel',
		channel: '/browse/channel/:channelId',
		channelAction: '/browse/channel/:channelId/:status',
		marketingArticle: '/browse/marketing-article/:_id/:campaignIdAndType?'
	},
	channels: {
		main: '/channels'
	},
	desk: {
		main: '/desk',
		edit: '/desk/:_id'
	},
	contributor: {
		main: '/contributor',
		edit: '/contributor/:_id'
	},
	tag: {
		main: '/tag',
		edit: '/tag/:_id'
	},
	archives: {
		main: '/archives',
		dateId: '/archives/:dateId'
	},
	topics: '/topics-page',
	promotion: '/promotion/:_id',
	forYou: '/for-you',
	subscriptions: '/subscriptions',
	channelSubscription: '/subscribe/channel/:channelId',
	channelSubscriptionPayment: '/subscribe/channel/confirm/:channelId',
	channelSubscriptionConfirmTrial: '/subscribe/channel/confirm-trial/:channelId',
	channelSubscriptionConfirmInterest: '/subscribe/channel/confirm-interest/:channelId',
	search: '/search',
	emailNotifications: '/email-notifications'
}
